import React from 'react'
import InstructorSurveyListCard from './components/InstructorSurveyListCard'
import { type InstructorDistribution } from '../../models/Distribution'
import Box from '@mui/material/Box'
import EmptyListCard from './components/EmptyListCard'
import PageHeader from '../../components/PageHeader'

export const instructorCardWidth = 720
interface InstructorSurveyListFeatureProps {
  list: InstructorDistribution[]
  /**
   * Paging context for the card's "survey N of M" aria-label. Without these, a screen reader
   * on page 2 would announce "survey 1 of 20" for the 21st survey. Optional so the component
   * still renders correctly for an unpaginated caller.
   */
  pageNumber?: number
  pageSize?: number
  totalResults?: number
}

const InstructorSurveyListFeature: React.FC<InstructorSurveyListFeatureProps> = ({
  list,
  pageNumber = 1,
  pageSize,
  totalResults
}): JSX.Element => {
  const cardsPerPage = pageSize ?? list?.length ?? 0
  const indexOffset = (pageNumber - 1) * cardsPerPage
  const announcedTotal = totalResults ?? list?.length
  return (
    <Box display='flex' flexDirection='column' maxWidth={instructorCardWidth} width='100%' margin='auto'>
      {list?.map((item, index) => {
        return (
          <InstructorSurveyListCard
            key={index}
            surveyNumber={indexOffset + index + 1}
            optOutDeadlineTimestamp={item?.optOutDeadlineTimestamp}
            totalSurveys={announcedTotal}
            courseName={item?.sectionDetails?.courseName}
            sectionAbbr={item?.sectionDetails?.sectionAbbr}
            endDate={item?.endTimestamp}
            startDate={item?.startTimestamp}
            releaseDate={item?.releaseTimestamp}
            surveyURL={item?.distributionUrl}
            distributionId={item?.distributionId}
            distributionSeriesId={item?.distributionSeriesId}
            reportURL={item?.sectionId}
            slotId={item?.slotId}
            slotNodeStatus={item?.slotNodeStatus}
            sectionId={item?.sectionId}
            completionCount={item?.completionDetails?.completionCount}
            studentCount={item?.completionDetails?.studentCount}
            slotTitle={item.slotTitle}
            distribution={item}
            isSlotAnonymous={item?.isSlotAnonymous ?? false}
            isInstructorAddedQuestionsAllowed={item?.isInstructorAddedQuestionsAllowed ?? false}
            isInstructorReleaseOnGradePostingEnabled={item?.isInstructorReleaseOnGradePostingEnabled}
            isSandbox={item?.isSandbox}
          />
        )
      })}
      {
        list.length === 0 && <EmptyListCard />
      }
    </Box>
  )
}

export default InstructorSurveyListFeature
